import { Box, Container, styled } from '@mui/material';
import { CarouselProps } from 'react-material-ui-carousel/dist/components/types';
import { PoolButton, PoolCarousel, useIsMobile } from '@synergy/components-next';
import { PoolInstance, isInstance } from '@synergy/config';
import { ReactElement } from 'react';
import { shouldForwardPropExclude } from '@synergy/utils';

import { HeaderBannerContent } from './header-banner-content';
import { HeaderBanner as HeaderBannerItem } from '../../models/header-banner';
import polygon from './header-banner-polygon.svg';

const CarouselImage = styled(Box, { shouldForwardProp: shouldForwardPropExclude('poolInstance') })<{
    image?: string;
}>(({ theme, image }) => ({
    display: 'flex',
    flexDirection: 'column-reverse',
    backgroundSize: 'cover',
    padding: theme.spacing(3, 0),
    backgroundImage: `linear-gradient(0deg, #2B6495 25.53%, rgba(43, 100, 149, 0.614679) 51.04%, rgba(43, 100, 149, 0) 72.91%), url(${image})`,
    backgroundRepeat: 'no-repeat',
    color: theme.palette.common.white,
    height: 424,

    [theme.breakpoints.up('sm')]: {
        height: 400,
        backgroundSize: isInstance(PoolInstance.CH) ? 'cover' : 'cover, auto 100%',
        backgroundImage: `linear-gradient(90.01deg, #2B6495 25.53%, rgba(43, 100, 149, 0.614679) 51.04%, rgba(43, 100, 149, 0) 72.91%), ${
            !isInstance(PoolInstance.CH) ? 'url(' + polygon + ' ) ,' : ''
        }url(${image})`,
        backgroundPosition: 'right',
    },
}));

export interface HeaderBannerProps extends CarouselProps {
    items: HeaderBannerItem[];
}

export const HeaderBanner = (props: HeaderBannerProps): ReactElement => {
    const { items } = props;
    const isMobile = useIsMobile();

    const handleBannerClick = (url?: string): void => {
        if (url) {
            window.open(url, '_blank');
        }
    };

    return (
        <PoolCarousel
            alignIndicatorButton="top"
            justifyIndicatorButton={isMobile ? 'right' : 'center'}
            sx={{ height: { xs: 424, sm: 400 } }}
            navButtonsAlwaysInvisible={true}
        >
            {items.map(item => (
                <CarouselImage key={item.id} image={isMobile ? item.mobileImage : item.image}>
                    <Container maxWidth="xl" sx={{ mb: { sm: 9 } }}>
                        <HeaderBannerContent headline={item.headline} subtitle={item.subHeadline}>
                            <Box sx={{ pt: { sm: 2.5, xs: 2 } }}>
                                {item.buttonUrl && (
                                    <PoolButton onClick={() => handleBannerClick(item.buttonUrl)}>
                                        {item.buttonText}
                                    </PoolButton>
                                )}
                            </Box>
                        </HeaderBannerContent>
                    </Container>
                </CarouselImage>
            ))}
        </PoolCarousel>
    );
};
